import { Component, computed, input } from '@angular/core';

import {
  buildUserSkinParameters,
  buildUserHairParameters,
  ParameterViewModel,
  SEVERITY_LEVELS,
  SKIN_PARAMETER_KEYS,
  HAIR_PARAMETER_KEYS,
  SkinParametersInfo,
  HairParametersInfo,
} from '../../../../helper/report-helper/report-helper';

@Component({
  selector: 'rebranded-report-parameter',
  imports: [],
  templateUrl: './rebranded-report-parameter.component.html',
})
export class RebrandedReportParameterComponent {
  readonly severityLevels = SEVERITY_LEVELS;
  readonly skinParameterKeys = SKIN_PARAMETER_KEYS;
  readonly hairParameterKeys = HAIR_PARAMETER_KEYS;
  skinParametersInfo = input<SkinParametersInfo | HairParametersInfo | null>();
  isHairReport = input<boolean>(false);
  parameters = input<ParameterViewModel[] | null>(null);

  userSkinParameters = computed<ParameterViewModel[]>((): ParameterViewModel[] => {
    const resolved = this.parameters();
    if (resolved) return resolved;
    if (this.isHairReport()) {
      return buildUserHairParameters(this.skinParametersInfo() as HairParametersInfo);
    }
    return buildUserSkinParameters(this.skinParametersInfo() as SkinParametersInfo);
  });

  getBubbleLeftPosition(scorePercentage: number): number {
    return Math.max(2, Math.min(100, scorePercentage));
  }
}
